/*

export interface TableFeature<TData extends RowData = any> {
  createCell?: (
    cell: Cell<TData, unknown>,
    column: Column<TData>,
    row: Row<TData>,
    table: Table<TData>
  ) => void
  createColumn?: (column: Column<TData, unknown>, table: Table<TData>) => void
  createHeader?: (header: Header<TData, unknown>, table: Table<TData>) => void
  createRow?: (row: Row<TData>, table: Table<TData>) => void
  createTable?: (table: Table<TData>) => void
  getDefaultColumnDef?: () => Partial<ColumnDef<TData, unknown>>
  getDefaultOptions?: (
    table: Table<TData>
  ) => Partial<TableOptionsResolved<TData>>
  getInitialState?: (initialState?: InitialTableState) => Partial<TableState>
}

*/

export const HiddenFeature = {

    getDefaultOptions() {
        return {
            enableHiddenColumns: true
        };
    },

    createColumn(column, table) {
        const { enableHiddenColumns } = table.options;
        const { hidden } = column.columnDef;

        if (enableHiddenColumns && hidden) {
            // column will ignore columnVisibility state and always be hidden
            column.getIsVisible = () => false;
        }
    },
};
